export const apiAuthorization = import.meta.env.VITE_REPORTS_AUTHORIZATION;
